/**
 * Loads the map of the office once its container is about to scroll into view, so that visitors who
 * never reach the footer download neither the map library nor its tiles.
 * @param {HTMLElement|null} container Element the map is rendered into
 */
export default function initLocationMap(container = document.getElementById('map')) {
  if (!container) {
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    if (entries.some((entry) => entry.isIntersecting)) {
      observer.disconnect();

      // The address is written next to the map, so a map that fails to load, e.g. for want of
      // WebGL, is left out
      import('./OfficeMap.mjs')
        .then(({ default: showMap }) => showMap(container))
        .catch(() => { container.hidden = true; }); // eslint-disable-line no-param-reassign
    }
  }, { rootMargin: '200px' });

  // Not before the page has loaded, as on short pages the footer is in view at once, and the map
  // would compete with the content for the network
  if (document.readyState === 'complete') {
    observer.observe(container);
  } else {
    window.addEventListener('load', () => observer.observe(container), { once: true });
  }
}
